import { CatalogEntry } from 'types';
import {
  ModalityExtension,
  OfferingCardEntry,
  SkillsAssessmentEntry,
} from './types';

export const isSkillsAssessmentEntry = (
  entry?: OfferingCardEntry,
): entry is SkillsAssessmentEntry =>
  entry?.modality === ModalityExtension.SkillsAssessment;

export const isCatalogEntry = (
  entry?: OfferingCardEntry,
): entry is CatalogEntry => entry != null && !isSkillsAssessmentEntry(entry);
